"use client";

import Section from "../Section";
const styles = new Proxy({"Faq":"Faq-5feae","accordion":"accordion-5feae","AccordionItem":"AccordionItem-5feae","accordion-header":"accordion-header-5feae"}, { get: (m, k) => (typeof k === "string" ? (m[k] ?? k) : m[k]) });
import { useState } from "react";
import { filterFilledItems } from "../../lib/filterFilledItems";

type FaqItem = {
  question: string;
  answer: string;
};

type FaqAccordionProps = {
  block: {
    title?: string;
    faqs?: FaqItem[];
  };
};

const DEFAULT_DATA: FaqItem[] = [
  {
    question: "How is gait recognition different from facial recognition?",
    answer:
      "It verifies identity from full-body motion and dimensions — works with masks, low light, and low-resolution videos — and enables cross-camera re-ID.",
  },
  {
    question: "How accurate is this technology?",
    answer:
      "During evaluation of our gait-recognition system, we achieved 98.3% accuracy (EER = 1.7%) by identifying individuals from a single gait cycle using only the computed thigh- and shank-flexion angles of both limbs. We estimate that incorporating the full set of dynamic parameters, adding static anthropometric features (e.g., segment lengths), and analyzing multiple gait cycles will boost accuracy to over 99.9% (EER < 0.1%).",
  },
  {
    question: "Do we need new cameras?",
    answer:
      "No. It runs on existing CCTV/IP cameras and integrates with leading VMS platforms.",
  },
  {
    question: "What other hardware is needed?",
    answer:
      "Modern CPU with 10+ cores and 3+ GHz clock speed\nNvidia GPU with 12+ GB VRAM, such as RTX 3060 or better\n16+ GB RAM",
  },
  {
    question: "What about privacy?",
    answer:
      "We default to feature-level processing (no face storage required), with configurable retention and full auditability.",
  },
  {
    question: "Will it handle large sites?",
    answer:
      "Yes—horizontally scalable across many cameras and multiple locations.",
  },
];

export default function Faq({ block }: FaqAccordionProps) {
  const { title, faqs } = block;
  const [activeFaqIndex, setActiveFaqIndex] = useState<number | null>(null);

  const filledFaqs = filterFilledItems(faqs, ["question", "answer"]);

  const usedData = filledFaqs?.length ? filledFaqs : DEFAULT_DATA;

  const toggleFaq = (e: any, index: number) => {
    e.preventDefault();
    e.stopPropagation();
    setActiveFaqIndex(activeFaqIndex === index ? null : index);
  };
  return (
    <Section title={title || "FAQ"} className={styles.Faq}>
      <div className="row">
        <div className="col-12 mb-5 pt-3">
          <div className="accordion" id="accordionExample">
            {usedData.map((item, index) => (
              <div className={styles.AccordionItem} key={item.question}>
                <h2 className="accordion-header" id={`heading${index}`}>
                  <button
                    className={`accordion-button ${activeFaqIndex !== index ? "collapsed" : ""}`}
                    type="button"
                    onClick={(e) => toggleFaq(e, index)}
                    aria-expanded={activeFaqIndex === index}
                    aria-controls={`collapse${index}`}
                  >
                    {item.question}
                  </button>
                </h2>
                <div
                  id={`collapse${index}`}
                  className={`accordion-collapse collapse ${activeFaqIndex === index ? "show" : ""}`}
                  aria-labelledby={`heading${index}`}
                >
                  <div className="accordion-body">{item.answer}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Section>
  );
}
